'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function (reinit) {
    if (reinit) {
        $(document).tooltip('destroy');
    }
    $(document).tooltip({
        items: '.tooltip',
        track: true,
        content: function () {
            return $(this).find('.tooltip-content').html();
        },
        position: {
            at: 'center bottom',
            my: 'left top+5px',
        }
    });

    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }

        $(target).toggleClass('active');
    });

    // alternative custom tooltip functionality
    const custTooltips = document.querySelectorAll('.custom-tooltip');
    let isScrolling = false;
    let scrollTimeout;

    function positionTooltip(e, contentEl) {
        const x = e.clientX || e.pageX;
        const y = e.clientY || e.pageY;
        
        let top = y + 20; // 20px below pointer
        let left = x + 10; // 10px to the right of pointer
        
        // Adjust if tooltip would go off-screen
        if (left + contentEl.offsetWidth > window.innerWidth) {
            left = window.innerWidth - contentEl.offsetWidth - 10;
        }
        if (top + contentEl.offsetHeight > window.innerHeight) {
            top = y - contentEl.offsetHeight - 10;
        }
        
        contentEl.style.top = `${top}px`;
        contentEl.style.left = `${left}px`;
    }

    custTooltips.forEach(tooltip => {
        const triggerEl = tooltip.querySelector('.custom-tooltip__icon');
        const contentEl = tooltip.querySelector('.custom-tooltip__content');
        let isTooltipActive = false;
        
        function showTooltip(e) {
            if (!isScrolling) {
                contentEl.classList.add('active');
                isTooltipActive = true;
                positionTooltip(e, contentEl);
            }
        }

        function hideTooltip() {
            contentEl.classList.remove('active');
            isTooltipActive = false;
        }

        function toggleTooltip(e) {
            if (isTooltipActive) {
                hideTooltip();
            } else {
                showTooltip(e);
            }
        }

        // Mouse events
        triggerEl.addEventListener('mouseenter', showTooltip);
        triggerEl.addEventListener('mouseleave', hideTooltip);
        triggerEl.addEventListener('mousemove', function(e) {
            if (!isScrolling && isTooltipActive) {
                positionTooltip(e, contentEl);
            }
        });

        // Touch events
        triggerEl.addEventListener('touchstart', function(e) {
            e.preventDefault(); // Prevent mouse events from firing
            toggleTooltip(e.touches[0]);
        });

        // Close tooltip when tapping outside
        document.addEventListener('touchstart', function(e) {
            if (isTooltipActive && !tooltip.contains(e.target)) {
                hideTooltip();
            }
        });
    });

    // Handle scrolling
    window.addEventListener('scroll', function() {
        isScrolling = true;
        custTooltips.forEach(tooltip => {
            tooltip.querySelector('.custom-tooltip__content').classList.remove('active');
        });
        
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
            isScrolling = false;
        }, 100);
    });
};
